export function getDateStatus(startDate:string,endDate:string,status:string,dataComplete:any) {
  let _startDateObject = new Date(startDate);
  let _endDateObject = new Date(endDate);
  var today = new Date();
  var ddCurrent = today.getDate();
  var mmCurrent = today.getMonth() + 1; 
  var yyyyCurrent = today.getFullYear();
  let _currentDate = new Date(yyyyCurrent+"-"+mmCurrent+"-"+ddCurrent).getTime();

  var ddStartDate = _startDateObject.getDate();
  var mmStartDate = _startDateObject.getMonth() + 1; 
  var yyyyStartDate = _startDateObject.getFullYear();
  let _startDate = new Date(yyyyStartDate+"-"+mmStartDate+"-"+ddStartDate).getTime();

  var ddEndDate = _endDateObject.getDate();
  var mmEndDate = _endDateObject.getMonth() + 1; 
  var yyyyEndDate = _endDateObject.getFullYear();
  let _endDate = new Date(yyyyEndDate+"-"+mmEndDate+"-"+ddEndDate).getTime(); 

  dataComplete = parseInt(dataComplete);
  if(status == "PUBLISHED"){
    if(_startDate <= _currentDate && _currentDate<=_endDate){
      return "LIVE0"
    }else if (_endDate < _currentDate){
      return "PAST0"
    }else if (_currentDate < _startDate){
      return "PUBLISHED0"
    }else{
      return "PUBLISHED0"
    }
  }

  if(status =="DRAFT"){
    if(dataComplete <= 20 ){
      return "DRAFT0"
    }else if(dataComplete > 20  && dataComplete <=40){
    return "DRAFT1"
    }else if(dataComplete > 40){
      return "DRAFT2"
    }
  }
}

  export function getGoals(param: any){
    const goalsArr: any = [];
    param = param || [];
    try {
      if (param.length > 0) {
        param.map(function (v: any, p: any) {
          goalsArr.push(v.name);
        });
      }
    } catch (e) {

    }
    return goalsArr;
  };
  
  export function getDate(startDate: any, endDate: any){
    if (startDate && endDate) {
      startDate = new Date(startDate);
      endDate = new Date(endDate);
      return startDate.getDate() + " " + startDate.toLocaleString('en-us', { month: 'short' }) + " " + startDate.getFullYear() + " to " + endDate.getDate() + " " + endDate.toLocaleString('en-us', { month: 'short' }) + " " + endDate.getFullYear();
    }
    else {
      return "";
    }
  }

  export function hourLeft(startDate: any, endDate: any){
    if (startDate && endDate) {
      startDate = new Date(startDate);
      endDate = new Date(endDate);
      return (Math.abs(endDate - startDate) / 36e5);
    }
    else {
      return "";
    }
  }

  export function getBatches(settingArr: any){
    let batches = settingArr.batches || []
    let batchArr: any = []
    batches.map(function (v: any, p: any) {
      batchArr.push(`${v.name}`);
    });
    
    return batchArr
  }
  export function getBatchesKeys(settingArr: any){
    let batches = settingArr.batches || []
    let batchArr: any = []
    batches.map(function (v: any, p: any) {
      batchArr.push(`${v._id}`);
    });
    
    return batchArr
  }
  export function getIntructors(batchData:any){
      var tempArr: any[] =[]
      batchData.map(function(v:any){
          v.instructors.map(function(v:any){
            tempArr.push(v.name)
          })
      })

      return tempArr
  }

  export function getGoalFirstLetter(param: any){
    const goalsArr: any = [];
    param = param || [];
    try {
      if (param.length > 0) {
        param.map(function (v: any, p: any) {
          goalsArr.push(v.name);
        });
      }
    } catch (e) {
    }
    return goalsArr;
  };

  export function getCourseID(){
    var courseID = (window.location.href)
		courseID = courseID.substring(courseID.lastIndexOf("/") + 1, courseID.length)
    return courseID
  }

  export function getPercentage(startDate: any, endDate: any){
    var currentDate = new Date().toISOString();
    var numberOfDays = days_between(startDate,endDate)
    var start_Current = days_between(startDate,currentDate)
    let percentage = Math.round(start_Current/numberOfDays *100) 
    return percentage > 99 ? 100 : percentage
  }

  export function getNoOfMonths(startDate: any, endDate: any){
    var currentDate = new Date().toISOString();
    var numberOfDays = days_between(startDate,endDate)
    // if(new Date(startDate).getTime() < new Date().getTime()){
    //   return getNumberOfDaysMonths(numberOfDays)
    // }
  
    var start_Current = days_between(currentDate,endDate)
    return getNumberOfDaysMonths(start_Current)
  }

  function getNumberOfDaysMonths(noOfDays:number){
    let numberOfMonth = Math.floor(noOfDays/30)
    let numberOfDays = noOfDays%30
    return "Left " +(numberOfMonth != 0 ? numberOfMonth + " Months " : "") + (numberOfDays != 0 ? numberOfDays +" Days" : "")
  }

  function days_between(date1:string, date2:string) {
    // The number of milliseconds in one day
    var ONE_DAY = 1000 * 60 * 60 * 24;

    // Convert both dates to milliseconds
    var date1_ms = new Date(date1).getTime();
    var date2_ms = new Date(date2).getTime();

    // Calculate the difference in milliseconds
    var difference_ms = Math.abs(date1_ms - date2_ms);

    // Convert back to days and return
    return Math.round(difference_ms/ONE_DAY);
}